<template>
	<div>
		<v-layout row wrap>
			<v-flex md12 text-xs-left>
				<h2 class="headline">Estado: {{ stateName }}</h2>
			</v-flex>
		</v-layout>
		<table-run v-bind:columns="columns"
				   v-bind:rows="rows"
				   v-bind:include-delete="false"
				   v-bind:include-search="true"
				   v-bind:include-export-to-excel="true"
				   v-bind:include-options="true"
				   v-bind:include-state="true"
				   v-on:on-sortable-event="columnSortableEvent"
				   v-on:on-export-selected="callServiceAndExport"
				   v-on:on-search-event="callServiceAndSearch">
			<template slot="rows" scope="props">
				<td>{{props.row.name}} {{props.row.lastname}}</td>
				<td>{{props.row.supervisor_name}} {{props.row.supervisor_lastname}}</td>
				<td>{{ stateName }}</td>
			</template>
		</table-run>
		<div v-if="rows.length === 0" class="mt-2">No se encontró data en este estado.</div>
	</div>
</template>

<script>
	import TableRun from 'table-run';
	import mixin from '@/shared/mixins';
	import housemaidResource from '@/resource/housemaid';

	function created() {
		this.resource = housemaidResource(this);
		this.loadData();
	}

	function callServiceAndExport(rows) {
		const fieldNames = this.columns.map(column => column.name);
		const columns = this.columns.map(column => column.code);
		this.exportToCSV(fieldNames, columns, rows, `Estado ${this.stateName}: Listado de mucamas.`);
	}

	function callServiceAndSearch(search) {
		this.search = this.renderFilter('name', search, 'ct');
		this.page = 1;
		this.loadData();
	}

	function columnSortableEvent({ id }) {
		const self = this;
		const newColumn = self.columns.filter(column => column.id === id);
		newColumn[0].isSortable = newColumn[0].isSortable.down ?
			{ down: false, up: true } : { down: true, up: false };
		self.columns = self.columns.map((columnSingle) => {
			const newColumnSingle = Object.assign({}, columnSingle);
			if (columnSingle.id !== newColumn[0].id && columnSingle.isSortable) {
				newColumnSingle.isSortable = { down: true, up: false };
			}
			return newColumnSingle;
		});
		const sortGroup = [];
		sortGroup.push(this.renderSort(newColumn[0].code, newColumn[0].isSortable.up ? 'ASC' : 'DSC'));
		this.sortFilter = sortGroup;
		this.loadData();
	}

	async function loadData() {
		const parameters = {
			page: this.page,
			limit: this.limit,
		};
		const filterGroups = [];
		if (this.stateId) {
			filterGroups.push(this.renderFilter('hk_ms_statehk_housemaid_id', this.stateId, 'eq'));
			parameters.filter_groups = filterGroups;
		}
		if (this.sortFilter) {
			parameters.sort = this.sortFilter;
		}
		if (this.search) {
			filterGroups.push(this.search);
			parameters.filter_groups = filterGroups;
		}
		const response = await this.resource.list(parameters);
		this.totalPages = response.data.last_page;
		this.rows = response.data.data;
	}

	export default {
		components: {
			TableRun,
		},
		created,
		data() {
			return {
				columns: [
					{ id: 1, name: 'Mucamas', code: 'name', isSortable: { down: true, up: false } },
					{ id: 2, name: 'Supervisor', code: 'supervisor_name', isSortable: { down: true, up: false } },
					{ id: 3, name: 'Estado', code: 'state' },
				],
				limit: 10,
				page: 1,
				resource: null,
				rows: [],
				search: null,
				sortFilter: null,
				totalPages: 5,
			};
		},
		methods: {
			callServiceAndExport,
			callServiceAndSearch,
			columnSortableEvent,
			loadData,
		},
		mixins: mixin,
		name: 'housemaids-by-state',
		props: ['stateId', 'stateName'],
	};
</script>




// WEBPACK FOOTER //
// HousemaidsByState.vue?38004fb2